import type {
	OrderDetailResponseDto,
	OrderStatus,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { StatusForm } from "Order/Components/Form/StatusForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";

type StatusCardWidgetProps = {
	status?: OrderStatus | null;
	storedStatus: OrderStatus;
	isDisabled?: boolean;
	order: OrderDetailResponseDto;
};

const orderResources = Resources.base.order.editForm;

export function StatusCardWidget({
	status,
	storedStatus,
	order,
	isDisabled = false,
}: StatusCardWidgetProps) {
	const { t } = useResource();
	return (
		<BaseCard title={t(orderResources.status)}>
			<StatusForm
				status={status}
				storedStatus={storedStatus}
				isDisabled={isDisabled}
				order={order}
			/>
		</BaseCard>
	);
}
